import { actions } from "@app/utils";
import { createApiClient } from "@app/utils/apiClient";

export const feedbackClient = createApiClient(
  actions["exd-storyteller-ai/feedback"],
);

export const submitFeedback = async (feedback, options = {}) => {
  const response = await feedbackClient.post("/", feedback, options);

  if (!response.ok) {
    throw new Error("Failed to submit feedback", { cause: response });
  }

  return response.data;
};
